export default __webpack_public_path__ + "static/media/logo-home.7be08766.png";